<mat-dialog-content #scroll class="dialog-container">
  <form [formGroup]="form">
    <mat-form-field class="col-12">
      <mat-label>Name</mat-label>
      <input
        matInput
        [formControlName]="'name'"
        [placeholder]="'Name'"
        [required]="required"
        (keypress)="alphaNumericWithCharacters($event)"
      />
      <mat-error>This field is required</mat-error>
    </mat-form-field>
    @if (!update) {
      <mat-form-field class="col-12">
        <mat-label>ID</mat-label>
        <input
          matInput
          [formControlName]="'id'"
          [placeholder]="'ID'"
          [required]="required"
          (keypress)="alphaNumericWithCharacters($event)"
        />
        <mat-error>This field is required</mat-error>
      </mat-form-field>
    }
    @if (update && rightData) {
      <div class="col-12 pb-4">Right ID: {{ rightData['id'] }}</div>
    }
    <mat-form-field class="col-12">
      <mat-label>Parent ID</mat-label>
      <mat-select matInput [formControlName]="'parentid'" [required]="required">
        @for (right of rights; track right) {
          <mat-option [value]="right">{{ right }}</mat-option>
        }
      </mat-select>
      <mat-error>This field is required</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="row buttons pb-4">
  <button mat-raised-button color="accent" (click)="save()">Save</button>
  <button mat-raised-button (click)="cancel()">Cancel</button>
  @if (update) {
    <button mat-raised-button color="warn" (click)="delete()" class="leftButton"
      >Delete</button
    >
  }
</mat-dialog-actions>
